import React, {useContext} from "react";
import {Link} from "react-router-dom";
import {Box, Button, Grid, Typography} from "@mui/material";
import Table from "../../../components/table/tableHistory";

import copyOutline from "../../../assets/images/copyOutline.svg";

import "./referralLinks.css";
import QRLink from "../../dashboard/refLink/qr";
import ShareLinks from "../../dashboard/refLink/shareLinks";
import {useGetReferralLink} from "../../../graphql/graphql/ref/hooks";
import RefTableHistory from "../../dashboard/refTableHistory";
import {CustomTooltip} from "../../../components/CustomTooltip";
import {MenuContext} from "../../../contexts/menuContext";

const payoutDetail = [
  {
    icon: "",
    title: "Referral link",
    detail: "example.com/ref=?11224422",
    button: (
      <Button className="btnEdit">
        Copy <img src={copyOutline} alt="copy" />
      </Button>
    ),
  },
];

const friendHeader = ["Email", "Date"];

const friendHistoryData = [
  {Email: "ab***@***.com", Date: "Dec 08, 2022 - 12:53 PM"},
  {Email: "ab***@***.us", Date: "Dec 08, 2022 - 12:53 PM"},
  {Email: "ab***@***.nl", Date: "Dec 08, 2022 - 12:53 PM"},
  {Email: "ab***@***.ru", Date: "Dec 08, 2022 - 12:53 PM"},
  {Email: "ab***@***.co.uk", Date: "Dec 08, 2022 - 12:53 PM"},
];

const ReferralLinks = () => {
  const {isSmall} = useContext(MenuContext);
  const {isLinkCopied, refLink, handleCopyLink} = useGetReferralLink();

  return (
    <Box className="referralLinksMain">
      <Typography variant="h4" className="setting_page_heading">
        Referral Links
      </Typography>
      <Typography className="linkTitle">
        Your friends get 20% OFF their first month when they use your link to register. Once you refer{" "}
        <span>3 friends</span>, your membership is <span>FREE</span>. You earn 15% monthly commission for extra
        referrals (i.e. if you refer 500 friends, you earn $4,500 per month— equivalent to a full-time income). This is 
        commonly called an affiliate program. However, most affiliate programs have a limit or are only a one-time commission, 
        yet they reap the benefits years after.
      </Typography>
      <Typography className="linkLabel">
        For your membership to remain free, you must <span>maintain</span> at least 3 active referrals.
      </Typography>
      {payoutDetail.map((payout, key) => (
        <Box className="acDetails" key={key}>
          <Typography variant="h6" display="flex" alignItems="center">
            {payout.icon} {payout.title}
          </Typography>
          <Box display="flex" alignItems="center" justifyContent="space-between">
            <Typography variant="h5">{refLink}</Typography>
            <CustomTooltip title={isLinkCopied ? "Copied to clipboard!" : "Copy to clipboard"}>
              <Button className="btnEdit" onClick={handleCopyLink}>
                {!isSmall && "Copy"} <img src={copyOutline} alt="copy" />
              </Button>
            </CustomTooltip>
          </Box>
        </Box>
      ))}
      <Box className="qrCodeSect">
        <Typography className="linkHeader">QR CODE</Typography>
        <QRLink />
        <ShareLinks />
      </Box>
      <Box className="my-referrals" my={3}>
        <Typography className="linkHeader">My referrals</Typography>
        <RefTableHistory />
      </Box>
    </Box>
  );
};

export default ReferralLinks;
